import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {createWorkerType, getWorkerType, listWorkerTypes, updateWorkerType} from './api'
import {workerTypeKeys} from './query-keys'
import type {CreateWorkerTypeInput, UpdateWorkerTypeInput} from './schemas'

export function useWorkerTypes(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: workerTypeKeys.types(),
        queryFn: listWorkerTypes,
        enabled: options?.enabled ?? true,
    })
}

export function useWorkerType(id: string) {
    return useQuery({
        queryKey: workerTypeKeys.type(id),
        queryFn: () => getWorkerType(id),
    })
}

export function useCreateWorkerType() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: CreateWorkerTypeInput) => createWorkerType(input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: workerTypeKeys.types()})
        },
    })
}

export function useUpdateWorkerType() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({id, input}: {id: string; input: UpdateWorkerTypeInput}) =>
            updateWorkerType(id, input),
        onSuccess: (_data, {id}) => {
            void queryClient.invalidateQueries({queryKey: workerTypeKeys.types()})
            void queryClient.invalidateQueries({queryKey: workerTypeKeys.type(id)})
        },
    })
}
